<template>
  <div class="notice-wrapper">
    <div class="notice-wrapper-cell">
      <div>公众号消息提醒</div>
      <mt-switch v-model="value" @change="turn"></mt-switch>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Notice',
  metaInfo: {
    title: '通知管理'
  },
  data () {
    return {
      value: false,
      type: 0
    }
  },
  computed: {
    ...mapState(['userId', 'villageId', 'wechatRemind'])
  },
  created () {
    // 小区状态
    // console.log(this.wechatRemind)
    if (this.wechatRemind === 1) {
      this.type = 1
      this.value = true
    } else if (this.wechatRemind === 0) {
      this.type = 0
      this.value = false
    }
  },
  methods: {
    ...mapMutations(['changeArgs']),
    // 切换
    turn: function () {
      // console.log(this.value)
      if (this.value === true) {
        this.type = 1
      } else {
        this.type = 0
      }
      this.axios.get('/wechat/index/repairRemind/village_member_id/' + this.userId + '/village_id/' + this.villageId + '/type/' + this.type)
        .then((res) => {
          if (res.data.status === 1) {
            this.changeArgs({wechatRemind: this.type})
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    }
  }
}
</script>
<style scoped>
.notice-wrapper {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 10px;
}
.notice-wrapper .notice-wrapper-cell {
  height: 50px;
  line-height: 50px;
  background-color: #ffffff;
  box-shadow: 0px 1px 0px 0px #f1f1f1;
  display: flex;
  padding: 0 20px;
  color: #191919;
  font-size: 14px;
  letter-spacing: 1px;
}
.notice-wrapper .notice-wrapper-cell div {
  flex: 1;
}
>>>
.mint-switch-input:checked + .mint-switch-core {
  border-color: #04c160;
  background-color: #04c160;
}
</style>



// WEBPACK FOOTER //
// src/components/Index/Notice.vue